
import $ from 'jquery';

import { EN_DEV } from '../helpers/GlobalsHelper';

/**
 * InputController
 *
 * adds events and functions used with input elements
 *
 * @param {object} settings see this.settingsDefault
 */
const InputController = function( settings ) {
	var that = this;
	this.settings = {};
	this.settingsDefault = {};

	// basic settings
	this.settingsDefault.eventElement = document;
	this.settingsDefault.eventNamespace = '.enInputController';

	// length counter settings
	this.settingsDefault.lengthCounter = {};
	this.settingsDefault.lengthCounter.counterSelector = '.input_count_wrapper';
	this.settingsDefault.lengthCounter.counterClass = 'input_count_wrapper';
	this.settingsDefault.lengthCounter.counterElement = 'p';
	this.settingsDefault.lengthCounter.pattern = '{current}/{max} ({remaining})';
	this.settingsDefault.lengthCounter.updateEvent = 'input propertychange';
	this.settingsDefault.lengthCounter.updateCallback = function( elements, data ) {
		if ( data.max != null ) elements.$counter.html( that.settings.lengthCounter.pattern.formatUsingObject( data ) );
		else elements.$counter.html();

		// limit chars
		if ( data.max && data.max < data.current ){
			elements.$input.val( data.value.substr( 0, data.max ) );
		}
	};


	// PROTECTED FUNCTIONS
	this.init = function( settings ) {

		that.settings = $.extend( true, {}, that.settingsDefault, settings );

		// implement required functions
		// string.format : http://stackoverflow.com/a/4673436
		if ( !String.prototype.format ) {
			String.prototype.formatUsingObject = function( obj ) {
				return this.replace( /{(.+?)}/g, function( match, key ) {
					return typeof obj[key] != 'undefined' ? obj[key] : match;
				} );
			};
		}
	};

	// length counter
	this.checkLengthCounterElement = function( $el ){
		var $counter = $el.parent().find( this.settings.lengthCounter.counterSelector );
		if ( $counter.length == 0 ) { // add counter if not existing
			$counter = $( '<' + this.settings.lengthCounter.counterElement + ' class="' + this.settings.lengthCounter.counterClass + '" />' );
			$el.after( $counter );
			if ( EN_DEV.Debug ) EN_DEV.Debug.info( 'InputController counter created: ', $counter );
		}

		return $counter;
	};


	// PUBLIC FUNCTIONS
	this.initLengthCounter = function( elSelector, callback ) {
		if ( typeof elSelector != 'string' ) {
			if ( EN_DEV.Debug ) EN_DEV.Debug.error( 'InputController cannot init length counter. element selector needs to be a string' );
			return false;
		}
		if ( typeof callback != 'function' ) {
			callback = this.settings.lengthCounter.updateCallback;
			if ( EN_DEV.Debug ) EN_DEV.Debug.info( 'InputController initializing length counter on', elSelector, 'using the default callback' );
		}
		else{
			if ( EN_DEV.Debug ) EN_DEV.Debug.info( 'InputController initializing length counter on', elSelector, 'using custom callback', callback );
		}

		// bind change event
		$( that.settings.eventElement ).off( this.settings.lengthCounter.updateEvent + ' update' + that.settings.eventNamespace );
		$( that.settings.eventElement ).on( this.settings.lengthCounter.updateEvent + ' update' + that.settings.eventNamespace, elSelector, function() {
			var $el = $( this );
			var data = {};
			var elements = {};

			// add data
			data.max = $el.attr( 'maxlength' ) ? $el.attr( 'maxlength' ) : null;
			data.value = $el.val();
			data.current = data.value.length;
			data.remaining = ( data.max ) ? data.max - data.current : null;

			// add elements
			elements.$counter = that.checkLengthCounterElement( $el );
			elements.$input = $el;

			// call user functions
			callback( elements, data );
		} );

		// trigger function once to update counts
		$( elSelector ).trigger( 'update' + that.settings.eventNamespace );


		return true;
	};


	/**
   * setupGroupChangeEvent
   * this adds a custom event to all input elements with the same name attribute whenever an event is triggered on one of them
   * @param  {string} elementSelector  	element to bind the event on
   * @param  {string} originalEventName	original event name
   * @param  {string} eventNameAll 		new event name (all with the same name-attribute)
   * @param  {string} eventNameOthers 	new event name (all with the same name-attribute but current)
   */
	this.setupGroupChangeEvent = function( elementSelector, pOriginalEventName, pEventNameAll, pEventNameOthers ){
		var that = this;
		var originalEventName = pOriginalEventName || 'change';
		var eventNameAll = pEventNameAll || originalEventName + 'GroupAll' + that.settings.eventNamespace;
		var eventNameOthers = pEventNameOthers || originalEventName + 'GroupOthers' + that.settings.eventNamespace;

		if ( EN_DEV.Debug ) EN_DEV.Debug.info( 'InputController seting up group events for: ', originalEventName, 'on: ', elementSelector );

		$( that.settings.eventElement ).on( originalEventName, elementSelector, function() {
			var $element = $( this );
			var name = $element.attr( 'name' );

			if ( name ) {
				var $all = $( elementSelector + '[name="' + name + '"]' );
				var $others = $all.not( $element );

				if ( EN_DEV.Debug ) EN_DEV.Debug.info( 'triggered', eventNameAll, 'on', $element );
				if ( EN_DEV.Debug ) EN_DEV.Debug.info( 'triggered', eventNameOthers, 'on', $element );

				$all.trigger( eventNameAll );
				$others.trigger( eventNameOthers );
			}
		} );
	};


	// "CONSTRUCTOR"
	this.init( settings );

};

export default InputController;
